import React from "react";
import { useTheme } from "styled-components";

const Announcements = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.625 2.813H3.375a.563.563 0 0 0-.562.562v11.25c0 .31.251.563.562.563h11.25c.31 0 .563-.252.563-.563V3.375a.56.56 0 0 0-.563-.562m-2.25-1.125v2.25m-6.75-2.25v2.25"
        stroke={theme.text.text}
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 8.438a1.687 1.687 0 1 1 3.375 0c0 2.25-3.375 3.937-3.375 3.937s-3.375-1.687-3.375-3.937a1.687 1.687 0 1 1 3.375 0"
        stroke={theme.text.text}
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Announcements;
